export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/5527993092922"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#25D366] hover:bg-[#128C7E] text-white px-5 py-3 rounded-full shadow-2xl transition-all duration-300 hover:scale-105 group"
    >
      <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
        <i className="ri-whatsapp-line text-xl w-6 h-6 flex items-center justify-center"></i>
      </div>
      <div className="flex flex-col">
        <span className="text-xs font-semibold uppercase tracking-wider">Atendimento</span>
        <span className="text-sm font-bold">WhatsApp</span>
      </div>
    </a>
  );
}